import { ColumnConfig, PrincipalSchemesColumnKey } from '../../model';

export const principalSchemeConfig: Record<
  PrincipalSchemesColumnKey,
  ColumnConfig
> = {
  schemeName: {
    name: 'Scheme Name & Code',
  },
  // skuCode: { name: 'SKU Code' },
  schemeTitle: { name: 'Product', field: 'component' },
  schemeType: { name: 'Scheme Type', field: 'component' },
  status: { name: 'Status', field: 'toolTip' },

  pts: {
    name: 'Price',
    sortField: 'ProductPrice',
    alignment: 'flex-end',
  },
  ptr: {
    name: 'Price With Margin',
    sortField: 'ProductPriceMargin',
    alignment: 'flex-end',
  },
  minQty: {
    name: 'Min Qty',
    sortField: 'minimumQty',
    alignment: 'flex-end',
  },
  freeQty: {
    name: 'Free Qty',
    sortField: 'freeQty',
    alignment: 'flex-end',
  },
  discount: {
    name: 'Discount',
    sortField: 'discount',
    alignment: 'flex-end',
  },
  action: {
    name: '',
    field: 'component',
  },
};
